import styled, { css } from "styled-components";
import { colours } from "../../../../../../styles/colours.constants";
import {
	satoshi500,
	satoshi700,
} from "../../../../../../styles/font.constants";

type CommentWrapperStyleProps = {
	$includeBottomBorder: boolean;
};

export const CommentWrapper = styled.div<CommentWrapperStyleProps>`
	display: flex;
	flex-direction: column;
	margin-bottom: 0.7rem;
	padding-bottom: 0.7rem;
	${({ $includeBottomBorder }) =>
		$includeBottomBorder && `border-bottom: solid 1px ${colours.greyDark}`}
`;

export const Comment = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const CommentCol = styled.div`
	display: flex;
	flex-direction: column;
`;

export const InnerContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 0.4rem;
`;

export const UserName = styled.div`
	${satoshi700}
	color: ${colours.black};
	font-size: 14px;
	margin-top: 5px;
`;

export const Text = styled.div`
	${satoshi500}
	font-size: 12px;
	color: ${colours.black};
	margin-top: 8px;
	display: flex;
	align-items: center;
	gap: 0.3rem;
	line-height: 150%;
	padding-right: 1.25rem;
`;

export const Actions = styled.div`
	margin-top: 0.4rem;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 0.6rem;
`;

export const MenuTrigger = styled.div`
	position: relative;
	background-color: ${colours.greyMedium};
	padding: 0.3rem;
	border-radius: 100%;
	width: 38px;
	height: 38px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	&:hover {
		background-color: ${colours.greyDark};
	}
`;

export const InputWrapper = styled.div`
	display: flex;
	gap: 0.6rem;
	margin-top: 0.8rem;
	padding-left: 1.7rem;
	padding-top: 0.2rem;
	padding-bottom: 0.3rem;
`;
